import React,{Component} from 'react';
import queryString from 'query-string'
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getPickSlip ,getProductDetails, savePack} from '../../actions/orderFulfillment'
import noImage from '../../assets/images/noProductImg_420x420.jpg'



class OrderDetails extends Component{

    constructor(){
        super()
        this.state = {
            details : [] ,
            display_arr: [],
            pickslip_details : [],
            barcode_no : ""
        
        }
    }
    componentDidMount(){
        let queries = queryString.parse(this.props.location.search)
        this.setState({
            details : queries})
        this.props.getProductDetails(this.props.connection_id,queries.fo_no)

        this.props.getPickSlip(this.props.connection_id,queries.fo_no)
       

    }
    handleChange(event) {
        this.setState({ [event.target.id]: event.target.value });
        
    }
    removeProduct(index1) {
var storedProducts = JSON.parse(localStorage.getItem("cart")); 
      
        storedProducts.splice(index1, 1);
        
localStorage.setItem('cart',JSON.stringify(storedProducts));
window.location.reload(false)
    }
    savePackOrder(){

        const pds = this.props.pickslip_details;
        let crt = localStorage.getItem("cart");
        
if(localStorage.getItem("cart") === null || localStorage.getItem("cart") == 'null'||JSON.parse(localStorage.getItem("cart")).length === 0){
    document.getElementById('error_display').innerHTML = 'Add Products to Pack'
    document.getElementById('error_display').style.color = 'red'
} else {

        const { savePack } = this.props
        var ps_no = '';
  

        if(pds && pds.length > 0){
            ps_no =  pds[0].pickslip_no;

        }
      
        var storedProducts = JSON.parse(localStorage.getItem("cart"));
        var product = [];
        var products = []
        if(storedProducts && storedProducts.length > 0)
        {
            storedProducts.map((sp,index)=>{
                product = {'PKD_SKU_CD' : sp.sku_code,'PKD_PACK_QTY' : sp.sku_qty }
                products.push(product)
            })
           

        }
        let option = {
            connection_id:this.props.connection_id,	
PKH_PICK_SLIP_NO:ps_no,	
PKH_CART_ORDER_NO:this.state.details.fo_no,	
PKH_PACK_METHOD:"M",	
PKH_SCAN_MODE:"B",	
PKD_CART_ORDER_NO:this.state.details.fo_no,	
PKD_PICK_SLIP_NO:ps_no,	
products:products

        }
savePack(option)
this.props.history.goBack()
localStorage.removeItem('cart')


    }
    }
    handleBack = () => {
       // localStorage.removeItem('cart')
        
        this.props.history.push('/pack')
    }
    handleScanner = () => {
        this.props.history.push('/csa-scanner')
      
    }
    getProducDetail(){
        const {getProductDetails} = this.props
        let arr = this.props.product_details;
        if(this.state.barcode_no === "" || this.state.barcode_no === undefined || this.state.barcode_no === null)
        {
            document.getElementById('error_display').style.color = 'red'
            document.getElementById('error_display').innerHTML = 'Please Enter Barcode'

        }
        else {
            document.getElementById('error_display').innerHTML = ''

        
    
        arr.map((pd,index)=>{
           
            if(pd.bar_code === this.state.barcode_no)
            {
                var allEntries = JSON.parse(localStorage.getItem("allEntries")) || [];

                const items = (() => {
                    const fieldValue = localStorage.getItem('cart');
                    return fieldValue === null
                      ? []
                      : JSON.parse(fieldValue);
                  })();
                  
                  // 3.
                  items.push(pd);
                  
                  // 4.
                  localStorage.setItem('cart', JSON.stringify(items));

              /*   this.setState({
                        display_arr : pd


                }) */
            window.location.reload(false)

            }
            else {
                document.getElementById('error_display').innerHTML = 'Enter available barcodes'
                document.getElementById('error_display').style.color = 'black'
            }


        })
    }
       // this.props.history.push(`/packdetail`)
    }
    render(){
    let colStyle = {
        wordBreak: 'break-all',
        paddingRight:2,
        paddingLeft:0

    }

//const cart = JSON.parse(localStorage.getItem(cart));
var storedProducts = JSON.parse(localStorage.getItem("cart")); 
var pds = this.props.pickslip_details;



        return(
            <section><div className='container' style={{maxWidth:'400px'}}>
                <div className='row ' ><div className='col' style={{textAlignLast:'center',paddingBottom:15}}>
                        <h5>Pack Order</h5></div>
                    </div>
                  <div className='container' style={{paddingBottom:90}}>
                <div className='container' style={{padding:0}}>
                    
                    <div className='row'>
                    <div className='col'>FO No
</div><div className='sm-col-1'>:</div>
<div className='col'>
{this.state.details.fo_no}
</div>

                    </div>
                    <div className='row'>
                    <div className='col'>FO Date
</div><div className='sm-col-1'>:</div>
<div className='col'>
{this.state.details.fo_date}
</div>

                    </div><div className='row'>
                    <div className='col'>CO No
</div><div className='sm-col-1'>:</div>
<div className='col'>
{this.state.details.co_no}

</div>
                    </div>

                    
                    <div className='row'>
                    <div className='col'>Pick Slip No
</div><div className='sm-col-1'>:</div>
<div className='col'>
{pds && pds.length >0 ? 
pds[0].pickslip_no : ''}
</div>
                    </div>

                </div>

              {storedProducts && storedProducts.length > 0 ?
              <React.Fragment>
                 
                      {  storedProducts.map((sp ,index)=>{
                           return(
                            <React.Fragment>
                <div className='container' id={index}>
                    <div className='row'>
                        <div className='col'>
                           <div> {sp.brand}/{sp.category}</div>
                           <div>{sp.sku_code}</div>
                           <div>{sp.color}/{sp.size}</div>
                           <div>{sp.sku_qty}</div>

                            
                            </div>
                            <div className='col'>
                                <div>
                                    <img src={sp.image !== null || sp.image !== "" ? sp.image : noImage} style={{ width: '65%' }} />
                                </div>
                            </div>
                    </div>
                  
                    <div className='row'>
                        <div className='col'></div>
                        <div className='col' style={{textAlignLast:'right'}}>
                    <button style={{border:'none'}} onClick={()=>this.removeProduct(index)}>X</button></div>
                    </div>
                    <br/>
                   
                </div>
                </React.Fragment>
              )
                }) }
                </React.Fragment>
                : ''
    }
               
                
              
                <div className='container' style={{padding:0}}>
                    <div className='row'>
                        <div className='col'>Enter Barcode</div>
                        <div className='sm-col-1'>:</div>
                        <div className='col'>

                        <input type="text" className="form-control" id="barcode_no"
                                                placeholder="Enter Barcode No" value={this.state.barcode_no} onChange={(e) => this.handleChange(e)} />
                           
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col'  style={{textAlignLast:'center',padding:10}}>
                        <button className="btn scanner-btn" style={{background:'transparent'}} onClick={(e) => this.handleScanner(e)}>Scan Barcode</button>
                        </div>

                        


                    </div>
                    <div className='row'><div className='col' style={{textAlignLast:'center',padding:15}}><button className='btn' onClick={(e) => this.getProducDetail(e)} >Go</button></div> </div>
                    
                   
                </div>
                </div>
                
                <div className='container' style={{maxWidth:'fit-content'}}>
                <div  id='error_display' className='bootom-bar' style={window.innerWidth > 1080 ? {bottom:'60px',position:"fixed",left:490 ,padding:10,width:'30vw',backgroundColor: "#FFFFFF"}:{bottom:'60px',position:"fixed" ,right:35,padding:10,width:'90vw',backgroundColor: "#FFFFFF"}}></div>
                    
                <div className='row bootom-bar' style={window.innerWidth > 1080 ? {position:"fixed",left:490 ,padding:10,width:'30vw',backgroundColor: "#FFFFFF"}:{position:"fixed" ,right:35,padding:10,width:'90vw',backgroundColor: "#FFFFFF"}}>
                    
                    <div className='col'>
                                <button className='btn btn-solid'  onClick={() => this.handleBack()}>BACK</button>
                            </div>
                        <div className='col'  ><button className='btn btn-solid'  style={{ float: "right" }} onClick={()=>this.savePackOrder()}>SAVE PACKSLIP</button></div>
                    </div></div></div>
            </section>
        )
    }


}
const mapStateToProps = (state, ownProps) => ({
    connection_id: state.tenant.connection_id,
    pickslip_details : state.orderFulfillment.slip_details,
    product_details : state.orderFulfillment.product_details



});


const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        { getPickSlip,getProductDetails,savePack},
        dispatch
    );


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(OrderDetails));